// ----------------------------------------------------------------------
//componanet
import { navBarTranslations } from "./components";
import { mealsPopUpTranslations } from "./components";
import { workoutStepperTranslations } from "./components";
import { formComponentTranslations } from "./components";
import { dashboardTranslations } from "./components";
import { mealVideoPopUpTranslations } from "./components";
import { snacksNoticePopUpTranslations } from "./components";
import {
  uploadMealPopUpTranslations,
  cancelUploadMealPopUpTranslations,
  workoutExplanationSectionTranslations,
  nutritionGuidanceSectionTranslations,
  tutorialPopUpTranslations,
} from "./components";
import {
  headerTranslations,
  printableNutritionTranslations,
} from "./components";
//pages
import {
  homeTranslations,
  workoutTranslations,
  supplementsTranslations,
  formTranslations,
  loginPageTranslations,
  bugReportPageTranslations,
  landingPageTranslations,
  signUpPageTranslations,
  formSubmittedPageTranslations,
  explanationTranslations,
  outOfRegionPageTranslations,
} from "./pages";

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const ar = {
  pagesTranslations: {
    homeTranslations,
    workoutTranslations,
    supplementsTranslations,
    formTranslations,
    loginPageTranslations,
    bugReportPageTranslations,
    landingPageTranslations,
    signUpPageTranslations,
    formSubmittedPageTranslations,
    explanationTranslations,
    outOfRegionPageTranslations,
  },
  commonSectionsTranslations: "",
  componentsTranslations: {
    headerTranslations,
    navBarTranslations,
    mealsPopUpTranslations,
    workoutStepperTranslations,
    formComponentTranslations,
    dashboardTranslations,
    mealVideoPopUpTranslations,
    snacksNoticePopUpTranslations,
    uploadMealPopUpTranslations,
    cancelUploadMealPopUpTranslations,
    workoutExplanationSectionTranslations,
    nutritionGuidanceSectionTranslations,
    tutorialPopUpTranslations,
    printableNutritionTranslations,
  },
};

export default ar;
